import { render } from "./DataRegistrasi.vue?vue&type=template&id=f45155e4"
import script from "./DataRegistrasi.vue?vue&type=script&lang=js"
export * from "./DataRegistrasi.vue?vue&type=script&lang=js"

import exportComponent from "E:\\WEB-APPS\\gizkia\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__